
export type Language = 'pt-BR' | 'en' | 'es' | 'fr';

export const translations = {
  'pt-BR': {
    nav_home: 'Home',
    nav_collection: 'Coleção',
    nav_add: 'Adicionar',
    nav_shop: 'Loja',
    nav_web: 'Web',
    nav_analysis: 'Botânico IA',
    nav_profile: 'Perfil',
    nav_info: 'Sobre',
    nav_logout: 'Sair',
    
    home_welcome: 'Olá',
    home_gardener: 'Jardineiro',
    home_slogan: 'Para ajudar você a catalogar e cuidar da sua coleção de plantas',
    home_specimens: 'Espécimes',
    home_alerts: 'Alertas',
    home_assistant: 'Centro de Pesquisa Botânica',
    home_assistant_placeholder: 'Pesquise espécies, curas ou métodos científicos...',
    home_checklist: 'Checklist de Hoje',
    home_recent: 'Adições Recentes',
    home_view_all: 'Ver todas',
    home_all_done: 'Tudo em dia!',
    home_empty: 'Seu jardim está vazio.',
    home_ai_sources: 'Fontes Consultadas',
    home_loading: 'Sintonizando Bancos de Dados...',
    home_ai_report: 'Relatório Científico',
    home_ai_action: 'Ação Inteligente',
    home_check: 'Checar',
    
    profile_title: 'Perfil',
    profile_personal_data: 'Dados Pessoais',
    profile_address: 'Endereço Residencial',
    profile_preferences: 'Preferências do App',
    profile_save: 'Salvar Alterações',
    profile_saving: 'Persistindo dados...',
    profile_theme: 'Tema',
    profile_language: 'Idioma',
    profile_success: 'Perfil salvo com sucesso!',
    profile_security: 'Segurança e Acesso',
    profile_change_email: 'Alterar E-mail da Conta',
    profile_new_email_placeholder: 'Novo e-mail',
    profile_change_password: 'Alterar Senha',
    profile_new_password_label: 'Nova Senha',
    profile_confirm_password_label: 'Confirmar Senha',
    profile_update_password_btn: 'Atualizar Senha',
    profile_delete_account_btn: 'Excluir Minha Conta',
    profile_delete_account_desc: 'Esta ação removerá permanentemente todos os seus dados e sua coleção botânica.',
    profile_delete_confirm_title: 'Excluir Tudo?',
    profile_delete_confirm_desc: 'Sua coleção, fotos e históricos serão apagados para sempre. Para começar do zero com o mesmo e-mail, basta entrar novamente após a exclusão.',
    profile_delete_yes: 'Sim, excluir tudo',
    profile_delete_no: 'Manter meu jardim',
    profile_delete_word: 'EXCLUIR',
    profile_delete_input_label: 'Digite EXCLUIR para confirmar',
    profile_delete_input_placeholder: 'EXCLUIR',
    profile_full_name_label: 'Nome Completo',
    profile_email_contact_label: 'E-mail de Contato',
    profile_age_label: 'Idade',
    profile_phone_label: 'Telefone',
    profile_cpf_label: 'CPF',
    profile_cep_label: 'CEP',
    profile_address_label: 'Rua / Número',
    profile_city_label: 'Cidade',
    profile_state_label: 'Estado',
    profile_syncing: 'Sincronizando...',
    
    analysis_title: 'Botânico IA',
    analysis_subtitle: 'Identificação e Saúde Botânica',
    analysis_take_photo: 'Tire uma foto nítida',
    analysis_gallery: 'ou selecione da sua galeria',
    analysis_analyzing_btn: 'Analisando Espécime...',
    analysis_start_btn: 'Iniciar Diagnóstico IA',
    analysis_result_title: 'Resultado da Análise',
    analysis_result_subtitle: 'Gerado via Gemini 1.5 Pro',
    analysis_reference: 'Referência',
    analysis_new_btn: 'Nova Análise',
    analysis_catalog_btn: 'Catalogar',
    analysis_processing_title: 'Processamento Neural',
    analysis_processing_desc: 'Nossa IA está cruzando dados de milhões de espécies para fornecer o diagnóstico mais preciso possível.',
    analysis_error: 'Ocorreu um erro na análise. Tente novamente.',
    
    form_tab_info: 'Info',
    form_tab_care: 'Manejo',
    form_tab_photos: 'Fotos',
    form_tab_health: 'Saúde',
    form_tab_loc: 'Local',
    form_common_name: 'Nome Popular',
    form_scientific_name: 'Nome Científico / Espécie *',
    form_genus: 'Gênero',
    form_family: 'Família',
    form_kingdom: 'Reino Plantae',
    form_category: 'Categoria',
    form_status: 'Status',
    form_date_acquisition: 'Data Aquisição',
    form_origin: 'Origem',
    form_notes: 'Anotações Gerais',
    form_sun_exposure: 'Exposição Solar',
    form_watering_freq: 'Frequência Rega',
    form_fertilizing_cycle: 'Ciclo Adubação',
    form_last_watering: 'Última Rega (Data)',
    form_fertilizer_type: 'Tipo de Adubo',
    form_reminders_title: 'Lembretes de Manutenção',
    form_reminder_watering: 'Rega',
    form_reminder_fertilizing: 'Adubação',
    form_reminder_pruning: 'Poda',
    form_reminder_repotting: 'Reenvasar',
    form_reminder_active: 'Ativo',
    form_reminder_inactive: 'Inativo',
    form_schedule_alarm: 'Agendar Alarme Nativo',
    form_gallery_title: 'Galeria da Planta',
    form_gallery_subtitle: 'Documente o crescimento',
    form_camera: 'Câmera',
    form_gallery: 'Galeria',
    form_treatments_title: 'Tratamentos Específicos',
    form_medication: 'Medicação / Vitaminas',
    form_pest_control: 'Controle de Pragas',
    form_treatment_instructions: 'Instruções de Tratamento',
    form_location_title: 'Localização',
    form_location_desc: 'Descrição ou Identificação do Local',
    form_confirm_edit: 'Confirmar Edição',
    form_register_plant: 'Cadastrar Planta',
    form_ai_fill: 'Preencher com IA',
    form_select_manual_kingdom: 'Selecionar Reino Manualmente',
    form_select_manual_category: 'Selecionar Categoria Manualmente',
    form_error_scientific_name: 'O campo Nome Científico / Espécie é obrigatório.',
    form_error_botanical_lookup: 'Não foi possível encontrar dados para este nome.',
    form_error_botanical_db: 'Erro ao consultar banco de dados botânico.',
    form_error_category_first: 'Selecione uma categoria primeiro.',
    form_error_save: 'Erro inesperado ao salvar.',
    
    form_placeholder_common: 'Ex: Rosa do Deserto',
    form_placeholder_scientific: 'Ex: Adenium obesum',
    form_placeholder_genus: 'Ex: Adenium',
    form_placeholder_family: 'Ex: Apocynaceae',
    form_placeholder_notes: 'Observações sobre o estado inicial, solo, vasos, etc.',
    form_placeholder_watering: 'Ex: 2x semana',
    form_placeholder_fertilizing: 'Ex: A cada 15 dias',
    form_placeholder_fertilizer_type: 'Fórmula ou nome do adubo',
    form_placeholder_medication: 'Ex: Vitamina B1, Fertilizante Mineral',
    form_placeholder_pest_control: 'Ex: Óleo de neem, Álcool isopropílico',
    form_placeholder_treatment_instructions: 'Descreva o passo a passo dos cuidados especializados.',
    form_placeholder_location: 'Ex: Quadrante Norte, Prateleira B...',
    
    form_calendar_desc: 'Agendado via Raizama Garden CARE.',
    form_calendar_alarm_desc: 'Lembrete Nativo Raizama',

    enum_succulents_cacti: 'Suculentas e cactos',
    enum_tropical_foliage: 'Folhagens tropicais',
    enum_orchids: 'Orquídeas',
    enum_trees_shrubs: 'Árvores e arbustos',
    enum_aquatic: 'Plantas aquáticas',
    enum_edible_garden: 'Horta comestível',
    enum_caudiciform: 'Caudiciforme',
    enum_medicinal: 'Medicinal',
    enum_briofitas: 'Briófitas',
    enum_pteridofitas: 'Pteridófitas',
    enum_gimnospermas: 'Gimnospermas',
    enum_angiospermas: 'Angiospermas',
    enum_healthy: 'Saudável',
    enum_observation: 'Observação',
    enum_sick: 'Doente',
    enum_full_sun: 'Sol pleno',
    enum_partial_shade: 'Meia-sombra',
    enum_shade: 'Sombra',
    
    details_origin_bought: 'Comprada',
    details_origin_collected: 'Coletada',
    details_origin_cultivated: 'Cultivo próprio',
    details_origin_clone: 'Clone',
    details_origin_seed: 'Semeio',
    details_origin_gift: 'Presente',
    details_not_found: 'Planta não encontrada.',
    details_status_sick: 'DOENTE',
    details_status_observation: 'OBSERVAÇÃO',
    details_status_healthy: 'SAUDÁVEL',
    details_tab_about: 'Sobre',
    details_tab_care: 'Manejo',
    details_tab_health: 'Saúde',
    details_tab_photos: 'Fotos',
    details_summary_title: 'Resumo Geral',
    details_summary_common_name: 'Nome Popular',
    details_summary_scientific_name: 'Nome Científico',
    details_summary_genus: 'Gênero',
    details_summary_family: 'Família',
    details_summary_kingdom: 'Reino Plantae',
    details_summary_category: 'Categoria',
    details_summary_status: 'Status',
    details_summary_origin: 'Origem',
    details_summary_acquisition: 'Aquisição',
    details_summary_location: 'Localização',
    details_summary_notes: 'Anotações',
    details_summary_no_notes: 'Sem anotações registradas.',
    details_geo_title: 'Localização Geográfica',
    details_geo_gps_active: 'GPS ATIVO',
    details_care_light: 'LUZ',
    details_care_watering: 'REGA',
    details_care_last_watering: 'Última Rega',
    details_care_watered_now: 'Reguei Agora',
    details_care_no_watering: 'Nenhum registro de rega.',
    details_care_at: 'às',
    details_care_check_humidity: 'Checar umidade',
    details_care_nutrients: 'Nutrientes',
    details_care_maintenance: 'Manutenção',
    details_care_repotting_desc: 'Verificar raízes e substrato.',
    details_care_alarm_title_pruning: '✂️ ALARME: Poda',
    details_care_alarm_title_repotting: '🪴 ALARME: Reenvasar',
    details_care_alarm_prefix_manejo: 'Manejo',
    details_care_alarm_prefix_adubo: 'Adubo',
    details_care_alarm_prefix_poda: 'Poda',
    details_care_alarm_native_desc: 'Lembrete de Cuidado Raizama',
    details_care_alarms_title: 'Alarme Nativo Automático',
    details_care_reminder_active: 'Lembrete Ativo',
    details_care_reminder_inactive: 'Inativo',
    details_care_schedule: 'Agendar',
    details_health_title: 'Registros de Saúde',
    details_health_medication: 'Medicação',
    details_health_no_medication: 'Nenhum registro.',
    details_health_pests: 'Pragas',
    details_health_pests_clean: 'Tudo limpo!',
    details_photos_reorder: 'Pressione e arraste para reordenar',
    details_photos_camera: 'Câmera',
    details_photos_gallery: 'Galeria',
    details_photo_delete_title: 'Remover Foto?',
    details_photo_delete_desc: 'Deseja remover esta imagem da galeria de {{name}}? Esta ação é irreversível.',
    details_photo_delete_btn: 'Remover Foto',
    details_delete_confirm_title: 'Excluir Permanente?',
    details_delete_confirm_desc: 'Todos os registros e as {{count}} fotos de {{name}} serão perdidos para sempre.',
    details_delete_confirm_btn: 'Sim, excluir planta',
    details_delete_cancel_btn: 'Manter no Jardim',
    details_share_copied: 'Informações da planta copiadas!',
    
    report_title: 'Relatório de Vitalidade',
    report_subtitle: 'Análise Profunda e Insights Botânicos',
    report_health_score: 'Score de Vitalidade',
    report_botanical_insight: 'Insight Botânico IA',
    report_care_strategy: 'Estratégia de Manejo',
    report_loading: 'Gerando Relatório...',
    report_generate_btn: 'Gerar Relatório IA',
    report_vitality_desc: 'Baseado no status atual e histórico de regas.',
    report_vitality_healthy: 'Seu espécime apresenta ótimos índices de turgidez e fotossíntese.',
    report_vitality_warning: 'Atenção necessária para evitar estresse hídrico ou nutricional.',
    report_tech_exposure: 'Exposição',
    report_tech_hydration: 'Hidratação',
    report_tech_nutrition: 'Nutrição',
    report_tech_immunity: 'Imunidade',
    report_ai_sync: 'Sincronizando com o Centro de Pesquisa...',
    report_ai_desc: 'Gere um relatório detalhado usando nossa IA para entender melhor as necessidades específicas desta espécie.',
    
    logout_confirm_title: 'Sair da Conta?',
    logout_confirm_desc: 'Deseja realmente sair? Você precisará entrar novamente para acessar sua coleção.',
    logout_cancel: 'Cancelar',
    logout_exit: 'Sair',

    layout_version: 'Versão',
    layout_identify: 'Identificar Planta',
    layout_about: 'Sobre o App',
    layout_profile: 'Perfil',
    layout_logout: 'Sair',

    auth_welcome: 'Seja Bem-Vindo!',
    auth_register: 'Cadastro',
    auth_forgot: 'Recuperar Acesso',
    auth_new_password: 'Nova Senha',
    auth_step: 'PASSO',
    auth_of: 'DE',
    auth_login_btn: 'Entrar',
    auth_google_btn: 'Entrar com Google',
    auth_no_account: 'Ainda não tem conta?',
    auth_register_link: 'Cadastre-se',
    auth_forgot_link: 'Esqueceu a senha?',
    auth_back_login: 'Voltar ao Login',
    auth_send_link: 'Enviar Link',
    auth_reset_btn: 'Redefinir Senha',
    auth_register_btn: 'Cadastrar',
    auth_already_account: 'Já possui conta?',
    auth_login_link: 'Faça Login',
    auth_email_label: 'E-mail',
    auth_password_label: 'Senha',
    auth_confirm_password_label: 'Confirmar Senha',
    auth_name_label: 'Nome',
    auth_age_label: 'Idade',
    auth_phone_label: 'Telefone',
    auth_cpf_label: 'CPF',
    auth_cep_label: 'CEP',
    auth_address_label: 'Endereço',
    auth_city_label: 'Cidade',
    auth_state_label: 'Estado',
    auth_photo_label: 'Foto de Perfil',
    auth_continue: 'Continuar',
    auth_back: 'Voltar',
    auth_advance: 'Avançar',

    coll_search_placeholder: 'Buscar na coleção...',
    coll_sort_by: 'Ordenar por',
    coll_plants_count: 'Plantas',
    coll_organized_by: 'Org. por',
    coll_empty: 'Nenhuma planta encontrada.',
    coll_new_tag: 'Novo',
    coll_recent_tag: 'Recém Adicionada',
    sort_name_common: 'Nome Comum',
    sort_name_scientific: 'Nome Científico',
    sort_category: 'Espécie/Categoria',
    sort_date: 'Data de Aquisição',
    sort_status: 'Status de Saúde',
  },
  'en': {
    nav_home: 'Home',
    nav_collection: 'Collection',
    nav_add: 'Add',
    nav_shop: 'Shop',
    nav_web: 'Web',
    nav_analysis: 'AI Botanist',
    nav_profile: 'Profile',
    nav_info: 'About',
    nav_logout: 'Logout',
    
    home_welcome: 'Hello',
    home_gardener: 'Gardener',
    home_slogan: 'To help you catalog and care for your plant collection',
    home_specimens: 'Specimens',
    home_alerts: 'Alerts',
    home_assistant: 'Botanical Research Center',
    home_assistant_placeholder: 'Search species, cures or scientific methods...',
    home_checklist: 'Today\'s Checklist',
    home_recent: 'Recent Additions',
    home_view_all: 'View all',
    home_all_done: 'All set!',
    home_empty: 'Your garden is empty.',
    home_ai_sources: 'Cited Sources',
    home_loading: 'Tuning Databases...',
    home_ai_report: 'Scientific Report',
    home_ai_action: 'Smart Action',
    home_check: 'Check',
    
    profile_title: 'Profile',
    profile_personal_data: 'Personal Data',
    profile_address: 'Home Address',
    profile_preferences: 'App Preferences',
    profile_save: 'Save Changes',
    profile_saving: 'Persisting data...',
    profile_theme: 'Theme',
    profile_language: 'Language',
    profile_success: 'Profile saved successfully!',
    profile_security: 'Security and Access',
    profile_change_email: 'Change Account Email',
    profile_new_email_placeholder: 'New email',
    profile_change_password: 'Change Password',
    profile_new_password_label: 'New Password',
    profile_confirm_password_label: 'Confirm Password',
    profile_update_password_btn: 'Update Password',
    profile_delete_account_btn: 'Delete My Account',
    profile_delete_account_desc: 'This action will permanently remove all your data and your botanical collection.',
    profile_delete_confirm_title: 'Delete Everything?',
    profile_delete_confirm_desc: 'Your collection, photos, and history will be deleted forever. To start from scratch with the same email, just sign in again after deletion.',
    profile_delete_yes: 'Yes, delete everything',
    profile_delete_no: 'Keep my garden',
    profile_delete_word: 'DELETE',
    profile_delete_input_label: 'Type DELETE to confirm',
    profile_delete_input_placeholder: 'DELETE',
    profile_full_name_label: 'Full Name',
    profile_email_contact_label: 'Contact Email',
    profile_age_label: 'Age',
    profile_phone_label: 'Phone',
    profile_cpf_label: 'CPF',
    profile_cep_label: 'CEP',
    profile_address_label: 'Street / Number',
    profile_city_label: 'City',
    profile_state_label: 'State',
    profile_syncing: 'Syncing...',
    
    analysis_title: 'AI Botanist',
    analysis_subtitle: 'Identification and Botanical Health',
    analysis_take_photo: 'Take a clear photo',
    analysis_gallery: 'or select from your gallery',
    analysis_analyzing_btn: 'Analyzing Specimen...',
    analysis_start_btn: 'Start AI Diagnosis',
    analysis_result_title: 'Analysis Result',
    analysis_result_subtitle: 'Generated via Gemini 1.5 Pro',
    analysis_reference: 'Reference',
    analysis_new_btn: 'New Analysis',
    analysis_catalog_btn: 'Catalog',
    analysis_processing_title: 'Neural Processing',
    analysis_processing_desc: 'Our AI is crossing data from millions of species to provide the most accurate diagnosis possible.',
    analysis_error: 'An error occurred during analysis. Please try again.',
    
    form_tab_info: 'Info',
    form_tab_care: 'Care',
    form_tab_photos: 'Photos',
    form_tab_health: 'Health',
    form_tab_loc: 'Location',
    form_common_name: 'Common Name',
    form_scientific_name: 'Scientific Name / Species *',
    form_genus: 'Genus',
    form_family: 'Family',
    form_kingdom: 'Kingdom Plantae',
    form_category: 'Category',
    form_status: 'Status',
    form_date_acquisition: 'Acquisition Date',
    form_origin: 'Origin',
    form_notes: 'General Notes',
    form_sun_exposure: 'Sun Exposure',
    form_watering_freq: 'Watering Frequency',
    form_fertilizing_cycle: 'Fertilizing Cycle',
    form_last_watering: 'Last Watering (Date)',
    form_fertilizer_type: 'Fertilizer Type',
    form_reminders_title: 'Maintenance Reminders',
    form_reminder_watering: 'Watering',
    form_reminder_fertilizing: 'Fertilizing',
    form_reminder_pruning: 'Pruning',
    form_reminder_repotting: 'Repotting',
    form_reminder_active: 'Active',
    form_reminder_inactive: 'Inactive',
    form_schedule_alarm: 'Schedule Native Alarm',
    form_gallery_title: 'Plant Gallery',
    form_gallery_subtitle: 'Document growth',
    form_camera: 'Camera',
    form_gallery: 'Gallery',
    form_treatments_title: 'Specific Treatments',
    form_medication: 'Medication / Vitamins',
    form_pest_control: 'Pest Control',
    form_treatment_instructions: 'Treatment Instructions',
    form_location_title: 'Location',
    form_location_desc: 'Location Description or ID',
    form_confirm_edit: 'Confirm Edit',
    form_register_plant: 'Register Plant',
    form_ai_fill: 'Fill with AI',
    form_select_manual_kingdom: 'Select Kingdom Manually',
    form_select_manual_category: 'Select Category Manually',
    form_error_scientific_name: 'The Scientific Name / Species field is required.',
    form_error_botanical_lookup: 'Could not find data for this name.',
    form_error_botanical_db: 'Error consulting botanical database.',
    form_error_category_first: 'Select a category first.',
    form_error_save: 'Unexpected error while saving.',
    
    form_placeholder_common: 'Ex: Desert Rose',
    form_placeholder_scientific: 'Ex: Adenium obesum',
    form_placeholder_genus: 'Ex: Adenium',
    form_placeholder_family: 'Ex: Apocynaceae',
    form_placeholder_notes: 'Notes about initial state, soil, pots, etc.',
    form_placeholder_watering: 'Ex: 2x week',
    form_placeholder_fertilizing: 'Ex: Every 15 days',
    form_placeholder_fertilizer_type: 'Fertilizer formula or name',
    form_placeholder_medication: 'Ex: Vitamin B1, Mineral Fertilizer',
    form_placeholder_pest_control: 'Ex: Neem oil, Isopropyl alcohol',
    form_placeholder_treatment_instructions: 'Describe step-by-step specialized care.',
    form_placeholder_location: 'Ex: North Quadrant, Shelf B...',
    
    form_calendar_desc: 'Scheduled via Raizama Garden CARE.',
    form_calendar_alarm_desc: 'Raizama Native Reminder',

    enum_succulents_cacti: 'Succulents and cacti',
    enum_tropical_foliage: 'Tropical foliage',
    enum_orchids: 'Orchids',
    enum_trees_shrubs: 'Trees and shrubs',
    enum_aquatic: 'Aquatic plants',
    enum_edible_garden: 'Edible garden',
    enum_caudiciform: 'Caudiciform',
    enum_medicinal: 'Medicinal',
    enum_briofitas: 'Bryophytes',
    enum_pteridofitas: 'Pteridophytes',
    enum_gimnospermas: 'Gymnosperms',
    enum_angiospermas: 'Angiosperms',
    enum_healthy: 'Healthy',
    enum_observation: 'Observation',
    enum_sick: 'Sick',
    enum_full_sun: 'Full sun',
    enum_partial_shade: 'Partial shade',
    enum_shade: 'Shade',
    
    details_origin_bought: 'Bought',
    details_origin_collected: 'Collected',
    details_origin_cultivated: 'Own Cultivation',
    details_origin_clone: 'Clone',
    details_origin_seed: 'Seed',
    details_origin_gift: 'Gift',
    details_not_found: 'Plant not found.',
    details_status_sick: 'SICK',
    details_status_observation: 'OBSERVATION',
    details_status_healthy: 'HEALTHY',
    details_tab_about: 'About',
    details_tab_care: 'Care',
    details_tab_health: 'Health',
    details_tab_photos: 'Photos',
    details_summary_title: 'General Summary',
    details_summary_common_name: 'Common Name',
    details_summary_scientific_name: 'Scientific Name',
    details_summary_genus: 'Genus',
    details_summary_family: 'Family',
    details_summary_kingdom: 'Kingdom Plantae',
    details_summary_category: 'Category',
    details_summary_status: 'Status',
    details_summary_origin: 'Origin',
    details_summary_acquisition: 'Acquisition',
    details_summary_location: 'Location',
    details_summary_notes: 'Notes',
    details_summary_no_notes: 'No notes recorded.',
    details_geo_title: 'Geographic Location',
    details_geo_gps_active: 'GPS ACTIVE',
    details_care_light: 'LIGHT',
    details_care_watering: 'WATERING',
    details_care_last_watering: 'Last Watering',
    details_care_watered_now: 'Watered Now',
    details_care_no_watering: 'No watering record.',
    details_care_at: 'at',
    details_care_check_humidity: 'Check humidity',
    details_care_nutrients: 'Nutrients',
    details_care_maintenance: 'Maintenance',
    details_care_repotting_desc: 'Check roots and substrate.',
    details_care_alarm_title_pruning: '✂️ ALARM: Pruning',
    details_care_alarm_title_repotting: '🪴 ALARM: Repotting',
    details_care_alarm_prefix_manejo: 'Management',
    details_care_alarm_prefix_adubo: 'Fertilizer',
    details_care_alarm_prefix_poda: 'Pruning',
    details_care_alarm_native_desc: 'Raizama Care Reminder',
    details_care_alarms_title: 'Automatic Native Alarm',
    details_care_reminder_active: 'Reminder Active',
    details_care_reminder_inactive: 'Inactive',
    details_care_schedule: 'Schedule',
    details_health_title: 'Health Records',
    details_health_medication: 'Medication',
    details_health_no_medication: 'No record.',
    details_health_pests: 'Pests',
    details_health_pests_clean: 'All clean!',
    details_photos_reorder: 'Press and drag to reorder',
    details_photos_camera: 'Camera',
    details_photos_gallery: 'Gallery',
    details_photo_delete_title: 'Remove Photo?',
    details_photo_delete_desc: 'Do you want to remove this image from {{name}}\'s gallery? This action is irreversible.',
    details_photo_delete_btn: 'Remove Photo',
    details_delete_confirm_title: 'Permanent Delete?',
    details_delete_confirm_desc: 'All records and the {{count}} photos of {{name}} will be lost forever.',
    details_delete_confirm_btn: 'Yes, delete plant',
    details_delete_cancel_btn: 'Keep in Garden',
    details_share_copied: 'Plant information copied!',
    
    report_title: 'Vitality Report',
    report_subtitle: 'Deep Analysis and Botanical Insights',
    report_health_score: 'Vitality Score',
    report_botanical_insight: 'AI Botanical Insight',
    report_care_strategy: 'Management Strategy',
    report_loading: 'Generating Report...',
    report_generate_btn: 'Generate AI Report',
    report_vitality_desc: 'Based on current status and watering history.',
    report_vitality_healthy: 'Your specimen shows great turgidity and photosynthesis rates.',
    report_vitality_warning: 'Attention needed to avoid water or nutritional stress.',
    report_tech_exposure: 'Exposure',
    report_tech_hydration: 'Hydration',
    report_tech_nutrition: 'Nutrition',
    report_tech_immunity: 'Immunity',
    report_ai_sync: 'Syncing with Research Center...',
    report_ai_desc: 'Generate a detailed report using our AI to better understand the specific needs of this species.',
    
    logout_confirm_title: 'Logout?',
    logout_confirm_desc: 'Do you really want to logout? You will need to sign in again to access your collection.',
    logout_cancel: 'Cancel',
    logout_exit: 'Exit',

    layout_version: 'Version',
    layout_identify: 'Identify Plant',
    layout_about: 'About App',
    layout_profile: 'Profile',
    layout_logout: 'Logout',

    auth_welcome: 'Welcome!',
    auth_register: 'Register',
    auth_forgot: 'Recover Access',
    auth_new_password: 'New Password',
    auth_step: 'STEP',
    auth_of: 'OF',
    auth_login_btn: 'Login',
    auth_google_btn: 'Login with Google',
    auth_no_account: 'No account yet?',
    auth_register_link: 'Sign up',
    auth_forgot_link: 'Forgot password?',
    auth_back_login: 'Back to Login',
    auth_send_link: 'Send Link',
    auth_reset_btn: 'Reset Password',
    auth_register_btn: 'Register',
    auth_already_account: 'Already have an account?',
    auth_login_link: 'Login',
    auth_email_label: 'Email',
    auth_password_label: 'Password',
    auth_confirm_password_label: 'Confirm Password',
    auth_name_label: 'Name',
    auth_age_label: 'Age',
    auth_phone_label: 'Phone',
    auth_cpf_label: 'CPF',
    auth_cep_label: 'CEP',
    auth_address_label: 'Address',
    auth_city_label: 'City',
    auth_state_label: 'State',
    auth_photo_label: 'Profile Photo',
    auth_continue: 'Continue',
    auth_back: 'Back',
    auth_advance: 'Next',

    coll_search_placeholder: 'Search in collection...',
    coll_sort_by: 'Sort by',
    coll_plants_count: 'Plants',
    coll_organized_by: 'Org. by',
    coll_empty: 'No plants found.',
    coll_new_tag: 'New',
    coll_recent_tag: 'Recently Added',
    sort_name_common: 'Common Name',
    sort_name_scientific: 'Scientific Name',
    sort_category: 'Species/Category',
    sort_date: 'Acquisition Date',
    sort_status: 'Health Status',
  },
  'es': {
    nav_home: 'Inicio',
    nav_collection: 'Colección',
    nav_add: 'Añadir',
    nav_shop: 'Tienda',
    nav_web: 'Web',
    nav_analysis: 'Botánico IA',
    nav_profile: 'Perfil',
    nav_info: 'Acerca de',
    nav_logout: 'Salir',
    
    home_welcome: 'Hola',
    home_gardener: 'Jardinero',
    home_slogan: 'Para ayudarte a catalogar e cuidar tu colección de plantas',
    home_specimens: 'Especímenes',
    home_alerts: 'Alertas',
    home_assistant: 'Centro de Investigación Botánica',
    home_assistant_placeholder: 'Busca especies, curas o métodos científicos...',
    home_checklist: 'Checklist de Hoy',
    home_recent: 'Adiciones Recientes',
    home_view_all: 'Ver todas',
    home_all_done: '¡Todo al día!',
    home_empty: 'Tu jardín está vacío.',
    home_ai_sources: 'Fuentes Consultadas',
    home_loading: 'Sintonizando Bases de Datos...',
    home_ai_report: 'Informe Científico',
    home_ai_action: 'Acción Inteligente',
    home_check: 'Comprobar',
    
    profile_title: 'Perfil',
    profile_personal_data: 'Datos Personales',
    profile_address: 'Dirección Residencial',
    profile_preferences: 'Preferencias de la App',
    profile_save: 'Guardar Cambios',
    profile_saving: 'Persistiendo datos...',
    profile_theme: 'Tema',
    profile_language: 'Idioma',
    profile_success: '¡Perfil guardado con éxito!',
    profile_security: 'Seguridad y Acceso',
    profile_change_email: 'Cambiar Correo de la Cuenta',
    profile_new_email_placeholder: 'Nuevo correo',
    profile_change_password: 'Cambiar Contraseña',
    profile_new_password_label: 'Nueva Contraseña',
    profile_confirm_password_label: 'Confirmar Contraseña',
    profile_update_password_btn: 'Actualizar Contraseña',
    profile_delete_account_btn: 'Eliminar Mi Cuenta',
    profile_delete_account_desc: 'Esta acción eliminará permanentemente todos tus datos y tu colección botánica.',
    profile_delete_confirm_title: '¿Eliminar Todo?',
    profile_delete_confirm_desc: 'Tu colección, fotos e historial se borrarán para siempre. Para empezar de cero con el mismo correo, simplemente inicia sesión de nuevo tras la eliminación.',
    profile_delete_yes: 'Sí, eliminar todo',
    profile_delete_no: 'Mantener mi jardín',
    profile_delete_word: 'ELIMINAR',
    profile_delete_input_label: 'Escribe ELIMINAR para confirmar',
    profile_delete_input_placeholder: 'ELIMINAR',
    profile_full_name_label: 'Nombre Completo',
    profile_email_contact_label: 'Correo de Contacto',
    profile_age_label: 'Edad',
    profile_phone_label: 'Teléfono',
    profile_cpf_label: 'CPF',
    profile_cep_label: 'CEP',
    profile_address_label: 'Calle / Número',
    profile_city_label: 'Ciudad',
    profile_state_label: 'Estado',
    profile_syncing: 'Sincronizando...',
    
    analysis_title: 'Botánico IA',
    analysis_subtitle: 'Identificación y Salud Botánica',
    analysis_take_photo: 'Toma una foto nítida',
    analysis_gallery: 'o selecciona de tu galería',
    analysis_analyzing_btn: 'Analizando Espécimen...',
    analysis_start_btn: 'Iniciar Diagnóstico IA',
    analysis_result_title: 'Resultado del Análisis',
    analysis_result_subtitle: 'Generado a través de Gemini 1.5 Pro',
    analysis_reference: 'Referencia',
    analysis_new_btn: 'Nuevo Análisis',
    analysis_catalog_btn: 'Catalogar',
    analysis_processing_title: 'Procesamiento Neural',
    analysis_processing_desc: 'Nuestra IA está cruzando datos de millones de especies para proporcionar el diagnóstico más preciso posible.',
    analysis_error: 'Ocurrió un error en el análisis. Inténtalo de nuevo.',
    
    form_tab_info: 'Info',
    form_tab_care: 'Manejo',
    form_tab_photos: 'Fotos',
    form_tab_health: 'Salud',
    form_tab_loc: 'Local',
    form_common_name: 'Nombre Común',
    form_scientific_name: 'Nombre Científico / Especie *',
    form_genus: 'Género',
    form_family: 'Familia',
    form_kingdom: 'Reino Plantae',
    form_category: 'Categoría',
    form_status: 'Estado',
    form_date_acquisition: 'Fecha de Adquisición',
    form_origin: 'Origen',
    form_notes: 'Notas Generales',
    form_sun_exposure: 'Exposición Solar',
    form_watering_freq: 'Frecuencia de Riego',
    form_fertilizing_cycle: 'Ciclo de Fertilización',
    form_last_watering: 'Último Riego (Fecha)',
    form_fertilizer_type: 'Tipo de Fertilizante',
    form_reminders_title: 'Recordatorios de Mantenimiento',
    form_reminder_watering: 'Riego',
    form_reminder_fertilizing: 'Fertilización',
    form_reminder_pruning: 'Poda',
    form_reminder_repotting: 'Trasplante',
    form_reminder_active: 'Activo',
    form_reminder_inactive: 'Inactivo',
    form_schedule_alarm: 'Programar Alarma Nativa',
    form_gallery_title: 'Galería de la Planta',
    form_gallery_subtitle: 'Documentar crecimiento',
    form_camera: 'Cámara',
    form_gallery: 'Galería',
    form_treatments_title: 'Tratamientos Específicos',
    form_medication: 'Medicación / Vitaminas',
    form_pest_control: 'Control de Plagas',
    form_treatment_instructions: 'Instrucciones de Tratamiento',
    form_location_title: 'Ubicación',
    form_location_desc: 'Descripción o Identificación del Local',
    form_confirm_edit: 'Confirmar Edición',
    form_register_plant: 'Registrar Planta',
    form_ai_fill: 'Completar con IA',
    form_select_manual_kingdom: 'Seleccionar Reino Manualmente',
    form_select_manual_category: 'Seleccionar Categoría Manualmente',
    form_error_scientific_name: 'El campo Nombre Científico / Especie es obligatorio.',
    form_error_botanical_lookup: 'No se pudieron encontrar datos para este nombre.',
    form_error_botanical_db: 'Error al consultar la base de datos botánica.',
    form_error_category_first: 'Selecciona una categoría primero.',
    form_error_save: 'Error inesperado al guardar.',
    
    form_placeholder_common: 'Ej: Rosa del Desierto',
    form_placeholder_scientific: 'Ej: Adenium obesum',
    form_placeholder_genus: 'Ej: Adenium',
    form_placeholder_family: 'Ej: Apocynaceae',
    form_placeholder_notes: 'Notas sobre el estado inicial, suelo, macetas, etc.',
    form_placeholder_watering: 'Ej: 2 veces por semana',
    form_placeholder_fertilizing: 'Ej: Cada 15 días',
    form_placeholder_fertilizer_type: 'Fórmula o nombre del abono',
    form_placeholder_medication: 'Ej: Vitamina B1, Fertilizante Mineral',
    form_placeholder_pest_control: 'Ej: Aceite de neem, Alcohol isopropílico',
    form_placeholder_treatment_instructions: 'Describe el paso a paso de los cuidados especializados.',
    form_placeholder_location: 'Ej: Cuadrante Norte, Estante B...',
    
    form_calendar_desc: 'Programado vía Raizama Garden CARE.',
    form_calendar_alarm_desc: 'Recordatorio Nativo Raizama',

    enum_succulents_cacti: 'Suculentas y cactus',
    enum_tropical_foliage: 'Follajes tropicales',
    enum_orchids: 'Orquídeas',
    enum_trees_shrubs: 'Árboles y arbustos',
    enum_aquatic: 'Plantas acuáticas',
    enum_edible_garden: 'Huerto comestible',
    enum_caudiciform: 'Caudiciforme',
    enum_medicinal: 'Medicinal',
    enum_briofitas: 'Briófitas',
    enum_pteridofitas: 'Pteridófitas',
    enum_gimnospermas: 'Gimnospermas',
    enum_angiospermas: 'Angiospermas',
    enum_healthy: 'Saludable',
    enum_observation: 'Observación',
    enum_sick: 'Enferma',
    enum_full_sun: 'Sol pleno',
    enum_partial_shade: 'Media sombra',
    enum_shade: 'Sombra',
    
    details_origin_bought: 'Comprada',
    details_origin_collected: 'Colectada',
    details_origin_cultivated: 'Cultivo propio',
    details_origin_clone: 'Clon',
    details_origin_seed: 'Semilla',
    details_origin_gift: 'Regalo',
    details_not_found: 'Planta no encontrada.',
    details_status_sick: 'ENFERMA',
    details_status_observation: 'OBSERVACIÓN',
    details_status_healthy: 'SALUDABLE',
    details_tab_about: 'Sobre',
    details_tab_care: 'Manejo',
    details_tab_health: 'Salud',
    details_tab_photos: 'Fotos',
    details_summary_title: 'Resumen General',
    details_summary_common_name: 'Nombre Común',
    details_summary_scientific_name: 'Nombre Científico',
    details_summary_genus: 'Género',
    details_summary_family: 'Familia',
    details_summary_kingdom: 'Reino Plantae',
    details_summary_category: 'Categoría',
    details_summary_status: 'Estado',
    details_summary_origin: 'Origen',
    details_summary_acquisition: 'Adquisición',
    details_summary_location: 'Ubicación',
    details_summary_notes: 'Notas',
    details_summary_no_notes: 'Sin notas registradas.',
    details_geo_title: 'Ubicación Geográfica',
    details_geo_gps_active: 'GPS ACTIVO',
    details_care_light: 'LUZ',
    details_care_watering: 'RIEGO',
    details_care_last_watering: 'Último Riego',
    details_care_watered_now: 'Regué Ahora',
    details_care_no_watering: 'Sin registro de riego.',
    details_care_at: 'a las',
    details_care_check_humidity: 'Comprobar humedad',
    details_care_nutrients: 'Nutrientes',
    details_care_maintenance: 'Mantenimiento',
    details_care_repotting_desc: 'Comprobar raíces y sustrato.',
    details_care_alarm_title_pruning: '✂️ ALARMA: Poda',
    details_care_alarm_title_repotting: '🪴 ALARMA: Trasplante',
    details_care_alarm_prefix_manejo: 'Manejo',
    details_care_alarm_prefix_adubo: 'Abono',
    details_care_alarm_prefix_poda: 'Poda',
    details_care_alarm_native_desc: 'Recordatorio de Cuidado Raizama',
    details_care_alarms_title: 'Alarma Nativa Automática',
    details_care_reminder_active: 'Recordatorio Activo',
    details_care_reminder_inactive: 'Inactivo',
    details_care_schedule: 'Programar',
    details_health_title: 'Registros de Salud',
    details_health_medication: 'Medicación',
    details_health_no_medication: 'Sin registro.',
    details_health_pests: 'Plagas',
    details_health_pests_clean: '¡Todo limpio!',
    details_photos_reorder: 'Presiona y arrastra para reordenar',
    details_photos_camera: 'Cámara',
    details_photos_gallery: 'Galería',
    details_photo_delete_title: '¿Eliminar Foto?',
    details_photo_delete_desc: '¿Deseas eliminar esta imagen de la galería de {{name}}? Esta acción es irreversible.',
    details_photo_delete_btn: 'Eliminar Foto',
    details_delete_confirm_title: '¿Eliminar Permanentemente?',
    details_delete_confirm_desc: 'Todos los registros y las {{count}} fotos de {{name}} se perderán para siempre.',
    details_delete_confirm_btn: 'Sí, eliminar planta',
    details_delete_cancel_btn: 'Mantener en el Jardín',
    details_share_copied: '¡Información de la planta copiada!',
    
    report_title: 'Informe de Vitalidad',
    report_subtitle: 'Análisis Profundo e Insights Botánicos',
    report_health_score: 'Puntuación de Vitalidad',
    report_botanical_insight: 'Insight Botánico IA',
    report_care_strategy: 'Estrategia de Manejo',
    report_loading: 'Generando Informe...',
    report_generate_btn: 'Generar Informe IA',
    report_vitality_desc: 'Basado en el estado actual e historial de riego.',
    report_vitality_healthy: 'Su espécimen muestra excelentes índices de turgencia y fotosíntesis.',
    report_vitality_warning: 'Se requiere atención para evitar estrés hídrico o nutricional.',
    report_tech_exposure: 'Exposición',
    report_tech_hydration: 'Hidratación',
    report_tech_nutrition: 'Nutrición',
    report_tech_immunity: 'Inmunidad',
    report_ai_sync: 'Sincronizando con el Centro de Investigación...',
    report_ai_desc: 'Genere un informe detallado usando nuestra IA para comprender mejor las necesidades específicas de esta especie.',
    
    logout_confirm_title: '¿Cerrar sessão?',
    logout_confirm_desc: '¿Realmente quieres salir? Deberás iniciar sesión de nuevo para acceder a tu colección.',
    logout_cancel: 'Cancelar',
    logout_exit: 'Salir',

    layout_version: 'Versión',
    layout_identify: 'Identificar Planta',
    layout_about: 'Sobre la App',
    layout_profile: 'Perfil',
    layout_logout: 'Salir',

    auth_welcome: '¡Bienvenido!',
    auth_register: 'Registro',
    auth_forgot: 'Recuperar Acceso',
    auth_new_password: 'Nueva Contraseña',
    auth_step: 'PASO',
    auth_of: 'DE',
    auth_login_btn: 'Entrar',
    auth_google_btn: 'Entrar con Google',
    auth_no_account: '¿Aún no tienes cuenta?',
    auth_register_link: 'Regístrate',
    auth_forgot_link: '¿Olvidaste tu contraseña?',
    auth_back_login: 'Volver al Login',
    auth_send_link: 'Enviar Enlace',
    auth_reset_btn: 'Restablecer Contraseña',
    auth_register_btn: 'Registrarse',
    auth_already_account: '¿Ya tienes cuenta?',
    auth_login_link: 'Inicia Sesión',
    auth_email_label: 'Correo electrónico',
    auth_password_label: 'Contraseña',
    auth_confirm_password_label: 'Confirmar Contraseña',
    auth_name_label: 'Nombre',
    auth_age_label: 'Edad',
    auth_phone_label: 'Teléfono',
    auth_cpf_label: 'CPF',
    auth_cep_label: 'CEP',
    auth_address_label: 'Dirección',
    auth_city_label: 'Ciudad',
    auth_state_label: 'Estado',
    auth_photo_label: 'Foto de Perfil',
    auth_continue: 'Continuar',
    auth_back: 'Volver',
    auth_advance: 'Avanzar',

    coll_search_placeholder: 'Buscar en la colección...',
    coll_sort_by: 'Ordenar por',
    coll_plants_count: 'Plantas',
    coll_organized_by: 'Org. por',
    coll_empty: 'No se encontraron plantas.',
    coll_new_tag: 'Nuevo',
    coll_recent_tag: 'Recién Añadida',
    sort_name_common: 'Nombre Común',
    sort_name_scientific: 'Nombre Científico',
    sort_category: 'Especie/Categoría',
    sort_date: 'Fecha de Adquisición',
    sort_status: 'Estado de Salud',
  },
  'fr': {
    nav_home: 'Accueil',
    nav_collection: 'Collection',
    nav_add: 'Ajouter',
    nav_shop: 'Boutique',
    nav_web: 'Web',
    nav_analysis: 'Botaniste IA',
    nav_profile: 'Profil',
    nav_info: 'À propos',
    nav_logout: 'Déconnexion',
    
    home_welcome: 'Bonjour',
    home_gardener: 'Jardinier',
    home_slogan: 'Pour vous aider à cataloguer et à soigner votre collection de plantes',
    home_specimens: 'Spécimens',
    home_alerts: 'Alertes',
    home_assistant: 'Centre de Recherche Botanique',
    home_assistant_placeholder: 'Recherchez des espèces, des remèdes ou des méthodes scientifiques...',
    home_checklist: 'Checklist du Jour',
    home_recent: 'Ajouts Récents',
    home_view_all: 'Voir tout',
    home_all_done: 'Tout est à jour !',
    home_empty: 'Votre jardin est vide.',
    home_ai_sources: 'Sources Consultées',
    home_loading: 'Synchronisation des Bases de Données...',
    home_ai_report: 'Rapport Scientifique',
    home_ai_action: 'Action Intelligente',
    home_check: 'Vérifier',
    
    profile_title: 'Profil',
    profile_personal_data: 'Données Personnelles',
    profile_address: 'Adresse Résidentielle',
    profile_preferences: 'Préférences de l\'App',
    profile_save: 'Enregistrer les Modifications',
    profile_saving: 'Persistance des données...',
    profile_theme: 'Thème',
    profile_language: 'Langue',
    profile_success: 'Profil enregistré avec succès !',
    profile_security: 'Sécurité et Accès',
    profile_change_email: 'Changer l\'E-mail du Compte',
    profile_new_email_placeholder: 'Nouvel e-mail',
    profile_change_password: 'Changer le Mot de Passe',
    profile_new_password_label: 'Nouveau Mot de Passe',
    profile_confirm_password_label: 'Confirmer le Mot de Passe',
    profile_update_password_btn: 'Mettre à jour le Mot de Passe',
    profile_delete_account_btn: 'Supprimer Mon Compte',
    profile_delete_account_desc: 'Cette action supprimera définitivement toutes vos données et votre collection botanique.',
    profile_delete_confirm_title: 'Tout Supprimer ?',
    profile_delete_confirm_desc: 'Votre collection, vos photos et votre historique seront supprimés pour toujours. Pour repartir de zéro avec le même e-mail, reconnectez-vous simplement après la suppression.',
    profile_delete_yes: 'Oui, tout supprimer',
    profile_delete_no: 'Garder mon jardin',
    profile_delete_word: 'SUPPRIMER',
    profile_delete_input_label: 'Tapez SUPPRIMER pour confirmer',
    profile_delete_input_placeholder: 'SUPPRIMER',
    profile_full_name_label: 'Nom Complet',
    profile_email_contact_label: 'E-mail de Contact',
    profile_age_label: 'Âge',
    profile_phone_label: 'Téléphone',
    profile_cpf_label: 'CPF',
    profile_cep_label: 'CEP',
    profile_address_label: 'Rue / Numéro',
    profile_city_label: 'Ville',
    profile_state_label: 'État',
    profile_syncing: 'Synchronisation...',
    
    analysis_title: 'Botaniste IA',
    analysis_subtitle: 'Identification et Santé Botanique',
    analysis_take_photo: 'Prenez une photo nette',
    analysis_gallery: 'ou sélectionnez dans votre galerie',
    analysis_analyzing_btn: 'Analyse du Spécimen...',
    analysis_start_btn: 'Démarrer le Diagnostic IA',
    analysis_result_title: 'Résultat de l\'Analyse',
    analysis_result_subtitle: 'Généré via Gemini 1.5 Pro',
    analysis_reference: 'Référence',
    analysis_new_btn: 'Nouvelle Analyse',
    analysis_catalog_btn: 'Cataloguer',
    analysis_processing_title: 'Traitement Neural',
    analysis_processing_desc: 'Notre IA croise les données de millions d\'espèces pour fournir le diagnostic le plus précis possible.',
    analysis_error: 'Une erreur est survenue lors de l\'analyse. Veuillez réessayer.',
    
    form_tab_info: 'Info',
    form_tab_care: 'Entretien',
    form_tab_photos: 'Photos',
    form_tab_health: 'Santé',
    form_tab_loc: 'Localisation',
    form_common_name: 'Nom Commun',
    form_scientific_name: 'Nom Scientifique / Espèce *',
    form_genus: 'Genre',
    form_family: 'Famille',
    form_kingdom: 'Règne Plantae',
    form_category: 'Catégorie',
    form_status: 'Statut',
    form_date_acquisition: 'Date d\'Acquisition',
    form_origin: 'Origine',
    form_notes: 'Notes Générales',
    form_sun_exposure: 'Exposition Solaire',
    form_watering_freq: 'Fréquence d\'Arrosage',
    form_fertilizing_cycle: 'Cycle de Fertilisation',
    form_last_watering: 'Dernier Arrosage (Date)',
    form_fertilizer_type: 'Type d\'Engrais',
    form_reminders_title: 'Rappels d\'Entretien',
    form_reminder_watering: 'Arrosage',
    form_reminder_fertilizing: 'Fertilisation',
    form_reminder_pruning: 'Taille',
    form_reminder_repotting: 'Rempotage',
    form_reminder_active: 'Actif',
    form_reminder_inactive: 'Inactif',
    form_schedule_alarm: 'Planifier Alarme Native',
    form_gallery_title: 'Galerie de la Plante',
    form_gallery_subtitle: 'Documenter la croissance',
    form_camera: 'Caméra',
    form_gallery: 'Galerie',
    form_treatments_title: 'Traitements Spécifiques',
    form_medication: 'Médication / Vitamines',
    form_pest_control: 'Contrôle des Nuisibles',
    form_treatment_instructions: 'Instructions de Traitement',
    form_location_title: 'Localisation',
    form_location_desc: 'Description ou ID de l\'Emplacement',
    form_confirm_edit: 'Confirmer la Modification',
    form_register_plant: 'Enregistrer la Plante',
    form_ai_fill: 'Remplir avec l\'IA',
    form_select_manual_kingdom: 'Sélectionner le Règne Manuellement',
    form_select_manual_category: 'Sélectionner la Catégorie Manuellement',
    form_error_scientific_name: 'Le champ Nom Scientifique / Espèce est obligatoire.',
    form_error_botanical_lookup: 'Impossible de trouver des données pour ce nom.',
    form_error_botanical_db: 'Erreur lors de la consultation de la base de données botanique.',
    form_error_category_first: 'Sélectionnez d\'abord une catégorie.',
    form_error_save: 'Erreur inattendue lors de l\'enregistrement.',
    
    form_placeholder_common: 'Ex : Rose du désert',
    form_placeholder_scientific: 'Ex : Adenium obesum',
    form_placeholder_genus: 'Ex : Adenium',
    form_placeholder_family: 'Ex : Apocynaceae',
    form_placeholder_notes: 'Notes sur l\'état initial, le sol, les pots, etc.',
    form_placeholder_watering: 'Ex : 2x par semaine',
    form_placeholder_fertilizing: 'Ex : Tous les 15 jours',
    form_placeholder_fertilizer_type: 'Formule ou nom de l\'engrais',
    form_placeholder_medication: 'Ex : Vitamine B1, Engrais Minéral',
    form_placeholder_pest_control: 'Ex : Huile de neem, Alcool isopropylique',
    form_placeholder_treatment_instructions: 'Décrivez étape par étape les soins spécialisés.',
    form_placeholder_location: 'Ex : Quadrant Nord, Étagère B...',
    
    form_calendar_desc: 'Planifié via Raizama Garden CARE.',
    form_calendar_alarm_desc: 'Rappel Natif Raizama',

    enum_succulents_cacti: 'Succulentes et cactus',
    enum_tropical_foliage: 'Feuillages tropicaux',
    enum_orchids: 'Orchidées',
    enum_trees_shrubs: 'Arbres et arbustes',
    enum_aquatic: 'Plantes aquatiques',
    enum_edible_garden: 'Potager comestible',
    enum_caudiciform: 'Caudiciforme',
    enum_medicinal: 'Médicinale',
    enum_briofitas: 'Bryophytes',
    enum_pteridofitas: 'Ptéridophytes',
    enum_gimnospermas: 'Gymnospermes',
    enum_angiospermas: 'Angiospermes',
    enum_healthy: 'Saine',
    enum_observation: 'Observation',
    enum_sick: 'Malade',
    enum_full_sun: 'Plein soleil',
    enum_partial_shade: 'Mi-ombre',
    enum_shade: 'Ombre',
    
    details_origin_bought: 'Achetée',
    details_origin_collected: 'Collectée',
    details_origin_cultivated: 'Culture propre',
    details_origin_clone: 'Clone',
    details_origin_seed: 'Semis',
    details_origin_gift: 'Cadeau',
    details_not_found: 'Plante non trouvée.',
    details_status_sick: 'MALADE',
    details_status_observation: 'OBSERVATION',
    details_status_healthy: 'SAINE',
    details_tab_about: 'À propos',
    details_tab_care: 'Entretien',
    details_tab_health: 'Santé',
    details_tab_photos: 'Photos',
    details_summary_title: 'Résumé Général',
    details_summary_common_name: 'Nom Commun',
    details_summary_scientific_name: 'Nom Scientifique',
    details_summary_genus: 'Genre',
    details_summary_family: 'Famille',
    details_summary_kingdom: 'Règne Plantae',
    details_summary_category: 'Catégorie',
    details_summary_status: 'Statut',
    details_summary_origin: 'Origine',
    details_summary_acquisition: 'Acquisition',
    details_summary_location: 'Emplacement',
    details_summary_notes: 'Notes',
    details_summary_no_notes: 'Aucune note enregistrée.',
    details_geo_title: 'Localisation Géographique',
    details_geo_gps_active: 'GPS ACTIF',
    details_care_light: 'LUMIÈRE',
    details_care_watering: 'ARROSAGE',
    details_care_last_watering: 'Dernier Arrosage',
    details_care_watered_now: 'Arrosé Maintenant',
    details_care_no_watering: 'Aucun enregistrement d\'arrosage.',
    details_care_at: 'à',
    details_care_check_humidity: 'Vérifier l\'humidité',
    details_care_nutrients: 'Nutriments',
    details_care_maintenance: 'Entretien',
    details_care_repotting_desc: 'Vérifier les racines et le substrat.',
    details_care_alarm_title_pruning: '✂️ ALARME : Taille',
    details_care_alarm_title_repotting: '🪴 ALARME : Rempotage',
    details_care_alarm_prefix_manejo: 'Gestion',
    details_care_alarm_prefix_adubo: 'Engrais',
    details_care_alarm_prefix_poda: 'Taille',
    details_care_alarm_native_desc: 'Rappel de Soin Raizama',
    details_care_alarms_title: 'Alarme Native Automatique',
    details_care_reminder_active: 'Rappel Actif',
    details_care_reminder_inactive: 'Inactif',
    details_care_schedule: 'Planifier',
    details_health_title: 'Registres de Santé',
    details_health_medication: 'Médication',
    details_health_no_medication: 'Aucun enregistrement.',
    details_health_pests: 'Nuisibles',
    details_health_pests_clean: 'Tout est propre !',
    details_photos_reorder: 'Appuyez et faites glisser pour réordonner',
    details_photos_camera: 'Caméra',
    details_photos_gallery: 'Galerie',
    details_photo_delete_title: 'Supprimer la Photo ?',
    details_photo_delete_desc: 'Voulez-vous supprimer cette image de la galerie de {{name}} ? Cette action est irréversible.',
    details_photo_delete_btn: 'Supprimer la Photo',
    details_delete_confirm_title: 'Supprimer Définitivement ?',
    details_delete_confirm_desc: 'Tous les enregistrements et les {{count}} photos de {{name}} seront perdus à jamais.',
    details_delete_confirm_btn: 'Oui, supprimer la plante',
    details_delete_cancel_btn: 'Garder dans le Jardin',
    details_share_copied: 'Informations sur la plante copiées !',
    
    report_title: 'Rapport de Vitalité',
    report_subtitle: 'Analyse Approfondie et Insights Botaniques',
    report_health_score: 'Score de Vitalité',
    report_botanical_insight: 'Insight Botanique IA',
    report_care_strategy: 'Stratégie d\'Entretien',
    report_loading: 'Génération du Rapport...',
    report_generate_btn: 'Générer Rapport IA',
    report_vitality_desc: 'Basé sur le statut actuel et l\'historique des arrosages.',
    report_vitality_healthy: 'Votre spécimen présente d\'excellents indices de turgidité et de photosynthèse.',
    report_vitality_warning: 'Attention nécessaire pour éviter un stress hydrique ou nutritionnel.',
    report_tech_exposure: 'Exposition',
    report_tech_hydration: 'Hydratation',
    report_tech_nutrition: 'Nutrition',
    report_tech_immunity: 'Immunité',
    report_ai_sync: 'Synchronisation com le Centre de Recherche...',
    report_ai_desc: 'Générez un rapport détaillé à l\'aide de notre IA pour mieux comprendre les besoins spécifiques de cette espèce.',
    
    logout_confirm_title: 'Déconnexion ?',
    logout_confirm_desc: 'Voulez-vous vraiment vous déconnecter ? Vous devrez vous reconnecter pour accéder à votre collection.',
    logout_cancel: 'Annuler',
    logout_exit: 'Quitter',

    layout_version: 'Version',
    layout_identify: 'Identifier la Plante',
    layout_about: 'À propos de l\'App',
    layout_profile: 'Profil',
    layout_logout: 'Déconnexion',

    auth_welcome: 'Bienvenue !',
    auth_register: 'Inscription',
    auth_forgot: 'Récupérer l\'Accès',
    auth_new_password: 'Nouveau Mot de Passe',
    auth_step: 'ÉTAPE',
    auth_of: 'SUR',
    auth_login_btn: 'Se connecter',
    auth_google_btn: 'Se connecter avec Google',
    auth_no_account: 'Pas encore de compte ?',
    auth_register_link: 'S\'inscrire',
    auth_forgot_link: 'Mot de passe oublié ?',
    auth_back_login: 'Retour à la connexion',
    auth_send_link: 'Envoyer le lien',
    auth_reset_btn: 'Réinitialiser le mot de passe',
    auth_register_btn: 'S\'inscrire',
    auth_already_account: 'Déjà un compte ?',
    auth_login_link: 'Se connecter',
    auth_email_label: 'E-mail',
    auth_password_label: 'Mot de passe',
    auth_confirm_password_label: 'Confirmer le mot de passe',
    auth_name_label: 'Nom',
    auth_age_label: 'Âge',
    auth_phone_label: 'Téléphone',
    auth_cpf_label: 'CPF',
    auth_cep_label: 'CEP',
    auth_address_label: 'Adresse',
    auth_city_label: 'Ville',
    auth_state_label: 'État',
    auth_photo_label: 'Photo de Profil',
    auth_continue: 'Continuer',
    auth_back: 'Retour',
    auth_advance: 'Suivant',

    coll_search_placeholder: 'Rechercher dans la collection...',
    coll_sort_by: 'Trier par',
    coll_plants_count: 'Plantes',
    coll_organized_by: 'Org. par',
    coll_empty: 'Aucune plante trouvée.',
    coll_new_tag: 'Nouveau',
    coll_recent_tag: 'Récemment Ajoutée',
    sort_name_common: 'Nom Commun',
    sort_name_scientific: 'Nom Scientifique',
    sort_category: 'Espèce/Catégorie',
    sort_date: 'Date d\'Acquisition',
    sort_status: 'État de Santé',
  }
};

export type TranslationKeys = keyof typeof translations['pt-BR'];

let currentLanguage: Language = 'pt-BR';

export const setLanguage = (lang: Language) => {
  currentLanguage = lang;
};

export const getLanguage = (): Language => currentLanguage;

export const t = (key: TranslationKeys): string => {
  return translations[currentLanguage][key] || key;
};
